import PaginationComponent from "../../../biblio/Pagination/PaginationComponent";
import { useNavigate } from "react-router-dom";
import { Col, Row, ConfigProvider, Empty, Input, Select } from "antd";
import React, { useEffect, useState, useRef } from "react";
import MenuItemLayout from "../menuItemLayout/MenuItemLayout";
import banner from "../../../assets/images/intern_banner.png";
import heroMobile from "../../../assets/images/intern-mob.png";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../apis/store";
import {
  getAllNews,
  getNewsCategories,
} from "../../../apis/actions/news.actions";
import DotsLoader from "../../../biblio/Loader/DotsLoader";
import PrimaryButton from "../../../biblio/Buttons/PrimaryButton";
import { LeftOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import pray from "../../../assets/icons/SelectIcon.svg";
import { scroll } from "../../../components/utils/utils";
import Loader from "../../../biblio/Loader/Loader";

const { Search } = Input;

const News = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch<AppDispatch>();
  const { data: news, loading } = useSelector(
    (state: RootState) => state?.news?.news
  );
  const newsCategories = useSelector(
    (state: RootState) => state?.news?.newsCategories
  );

  const [activePage, setActivePage] = useState(1);
  const [selectedCategory, setSelectedCategory] = useState<number | null>(null);
  const [inputValue, setInputValue] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredNews, setFilteredNews] = useState<any[]>([]);
  const [searchPerformed, setSearchPerformed] = useState(false);
  const itemsPerPage = 6;
  const currentRef = useRef<HTMLDivElement>(null);

  const navigate = useNavigate();

  useEffect(() => {
    dispatch(getAllNews());
    dispatch(getNewsCategories());
  }, [dispatch]);

  useEffect(() => {
    setFilteredNews(news);
  }, [news]);

  const handleSearch = () => {
    setActivePage(1);
    setSearchPerformed(true);
    setSearchTerm(inputValue);
    if (!selectedCategory && !inputValue) {
      setFilteredNews(news);
    } else {
      const filtered = news.filter(
        (item: any) =>
          (!selectedCategory || item.category_id === selectedCategory) &&
          (!inputValue ||
            item.title.includes(inputValue) ||
            item.resume.includes(inputValue))
      );
      setFilteredNews(filtered);
    }
  };
  useEffect(() => {
    handleSearch();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedCategory, searchTerm, news]);

  useEffect(() => {
    if (!selectedCategory && !searchTerm) {
      setFilteredNews(news);
      setSearchPerformed(false);
    }
  }, [selectedCategory, searchTerm, news]);

  const sortedNews = [...filteredNews].sort(
    (a, b) =>
      new Date(b.published_date).getTime() -
      new Date(a.published_date).getTime()
  );
  const paginatedNews = sortedNews.slice(
    (activePage - 1) * itemsPerPage,
    activePage * itemsPerPage
  );

  const handleCardClick = (id: number) => {
    navigate("/news/details", { state: { id } });
  };

  useEffect(() => {
    dispatch(getAllNews());
  }, [dispatch]);

  const updateActivePage = (pageNumber: number) => {
    setActivePage(pageNumber);
    scroll(currentRef);
  };

  if (loading) {
    return <Loader />;
  }

  return (
    <MenuItemLayout
      mobileImage={heroMobile}
      title="المركز الإعلامي"
      subTitle="الأخبار"
      urlImage={banner}
    >
      <div
        className="takaful--cases-header takaful--news-header"
        ref={currentRef}
      >
        <div className="takaful--cases-header-content">
          <div className="takaful--cases-header-box">
            <img alt="" src={pray} />
            <ConfigProvider
              renderEmpty={() => (
                <Empty
                  description={
                    <span className="takaful--select-empty">
                      لا توجد بيانات
                    </span>
                  }
                />
              )}
            >
              <Select
                showSearch
                placeholder="اختر الصنف"
                className="takaful--select takaful--selects"
                value={selectedCategory}
                onChange={(value) => setSelectedCategory(value)}
                allowClear
                options={newsCategories.map((category: any) => ({
                  label: category.name,
                  value: category.name,
                }))}
                dropdownRender={(menu) => (
                  <div className="takaful--select-dropdown">{menu}</div>
                )}
                popupMatchSelectWidth={300}
                onClear={() => {
                  setSelectedCategory(null);
                  setSearchTerm("");
                }}
              />
            </ConfigProvider>
          </div>
          <Search
            placeholder="ادخل كلمة البحث"
            allowClear
            className="takaful--search"
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            onSearch={handleSearch}
            onClear={() => {
              setInputValue("");
              setSearchTerm("");
            }}
          />
          <PrimaryButton
            className="takaful--primary-button"
            icon={<LeftOutlined />}
            title={t("cases.button")}
            onClick={handleSearch}
          />
        </div>
      </div>
      <>
        {loading ? (
          <div className="takaful--loading-branches">
            <DotsLoader />
            <p className="takaful--no-project-message">جارٍ التحميل</p>
          </div>
        ) : news?.length === 0 ? (
          <p className="takaful--no-services" style={{ marginTop: "5rem" }}>
            لا توجد اخبار
          </p>
        ) : searchPerformed && filteredNews.length === 0 ? (
          <p className="takaful--no-news-message">
            لا توجد اخبار تتوافق مع البحث الذي قمت به
          </p>
        ) : (
          <>
            <Row dir="rtl" gutter={16} className="takaful--news-row">
              {paginatedNews.map((item: any) => (
                <Col
                  key={item.id}
                  xxl={8}
                  xl={8}
                  lg={8}
                  md={12}
                  sm={24}
                  xs={24}
                  className="takaful--news-Columns"
                  onClick={() => handleCardClick(item.id)}
                >
                  <div className="takaful--news-card">
                    <img
                      src={`data:image/png;base64,${item.image}`}
                      alt={item.title}
                    />
                    <div className="takaful--news-card-description">
                      <p className="takaful--news-card-date">
                        {new Date(item.published_date).toLocaleDateString()}
                      </p>
                      <p className="takaful--news-card-title">{item.title}</p>
                    </div>
                    <div>
                      <p className="takaful--news-card-resume">{item.resume}</p>
                    </div>
                  </div>
                </Col>
              ))}
            </Row>
            {filteredNews.length > itemsPerPage && (
              <PaginationComponent
                total={filteredNews.length}
                active={activePage}
                itemPerPage={itemsPerPage}
                setActive={updateActivePage}
              />
            )}
          </>
        )}
      </>
    </MenuItemLayout>
  );
};

export default News;
